
import { appendDescriptionAttribute } from '../../../shared/model-description.util';
import { AssetTypeInfo } from '../../asset/model/asset.typeinfo';
import { FIREARM_TYPE_MODERATOR } from '../../domain-constants';
import { Firearm } from './firearm.model';
import { FirearmTypeInfoBase } from './firearm.typeinfo.base';


export class FirearmTypeInfo extends FirearmTypeInfoBase {
  name = 'Firearm Asset';

  auditRouteBase = ["/firearm/audit"];

  assetTypeInfo: AssetTypeInfo = new AssetTypeInfo();

  description(item: Firearm): string {
    var description = appendDescriptionAttribute(item?.asset?.description);
    description = appendDescriptionAttribute(item?.asset?.manufacturer, description, true);
    description = appendDescriptionAttribute(item?.asset?.model, description, true);
    description = appendDescriptionAttribute(item?.asset?.identityReference, description, true);
    return description;
  }

  typeName(item: Firearm): string {
    if (item?.firearmType != null) {
      if (item.firearmType == FIREARM_TYPE_MODERATOR) {
        return 'Moderator';
      } else {
        return 'Firearm';
      }
    } else {
      return this.name;
    }
  }
}

export const FIREARM_TYPE: FirearmTypeInfo = new FirearmTypeInfo();



